import { getQuoteLimit } from '@/api/apply-product';
import { QuoteLimitRequestType } from '@/api/apply-product/types';
import { ubtModuleExposeNew } from '@/shared/utils/ubt';
import { Dialog } from '@hb/coffee';

export enum ClickTypeEnum {
  CANCEL = '1',
  CHANGE_CHANNEL = '2',
}

export const QuoteLimiteButtonName = {
  [ClickTypeEnum.CANCEL]: '我知道了',
  [ClickTypeEnum.CHANGE_CHANNEL]: '去其他通道',
};

export type AutarkyLimitReturnType = {
  result: boolean,
  clickType?: ClickTypeEnum,
  buttonName?: string
}

export const showAutarkyLimitDialog = ()
:Promise<AutarkyLimitReturnType> => new Promise((resolve) => {
  ubtModuleExposeNew(
    '臻有钱_提现申请页',
    'fincance_loan_normalapply_limitPopup_expose',
  );
  Dialog.alert({
    title: '提示',
    message: '由于您选择的提现机构当前时段额度受限，暂时无法完成您的本次提现操作',
    closeable: false,
    confirmButtonText: '我知道了',
    // cancelButtonText: QuoteLimiteButtonName[ClickTypeEnum.CANCEL],
  }).then(() => {
    resolve({
      result: false,
      // clickType: ClickTypeEnum.CHANGE_CHANNEL,
      // buttonName: QuoteLimiteButtonName[ClickTypeEnum.CHANGE_CHANNEL],
    });
  }).catch(() => {
    Dialog.close();
    resolve({
      result: false,
      // clickType: ClickTypeEnum.CANCEL,
      // buttonName: QuoteLimiteButtonName[ClickTypeEnum.CANCEL],
    });
  });
});
export const checkAutarkyLimit = async (
  params: QuoteLimitRequestType,
): Promise<AutarkyLimitReturnType> => {
  let checkRes;
  try {
    checkRes = await getQuoteLimit({
      ...params,
    });
  } catch (error) {
    checkRes = {
      result: false,
    };
  }

  if (checkRes.result) {
    const res = await showAutarkyLimitDialog();
    return res;
  }
  return Promise.resolve({
    result: true,
  });
};
